import script from "./CustomMakercartSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomMakercartSection.vue?vue&type=script&setup=true&lang=js"

import "./CustomMakercartSection.vue?vue&type=style&index=0&id=500cd9b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500cd9b0"]])

export default __exports__